(() => {
  const pending = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-klaviyo-signup]')) return;
    event.preventDefault();
    if (pending.has(form)) return;

    const status = form.querySelector('[role="status"]');
    const localHost = /^(localhost|127(?:\.\d+){3}|0\.0\.0\.0|\[?::1\]?)$/.test(location.hostname)
      || /\.(localhost|local)$/.test(location.hostname);
    if (localHost || form.hasAttribute('data-local-form')) {
      status.textContent = 'Local preview only. Nothing has been sent or saved.';
      return;
    }
    if (!form.reportValidity()) return;

    const email = form.querySelector('input[type="email"]');
    const listId = form.querySelector('input[name="g"]').value;
    const companyId = form.dataset.klaviyoCompany;
    const button = form.querySelector('button[type="submit"]');
    const source = `BOXBOX website: ${form.dataset.signupSource}`;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    pending.add(form);
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'Submitting…';

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: '2026-10-15',
        },
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email.value.trim(),
                    properties: { boxbox_signup_source: form.dataset.signupSource },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      });
      if (response.status !== 202) {
        status.textContent = response.status === 429
          ? 'Please wait a moment, then try again.'
          : 'We couldn’t complete your signup. Please try again.';
        return;
      }
      form.reset();
      status.textContent = 'Thank you for joining. Your signup has been received.';
    } catch {
      status.textContent = 'We couldn’t confirm your signup. Please check your connection and try again.';
    } finally {
      clearTimeout(timeout);
      pending.delete(form);
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
})();
